import { useMemo } from "react";

import { friendlyDefaultDisplayValue } from "utilities/helpers";

import { BTSelect } from "commonComponents/btWrappers/BTSelect/BTSelect";
import type { CustomFieldDefinition } from "commonComponents/entity/customField/utils/customFieldDefinition.util";
import {
    getOptionsFromDefinition,
    parseCommaSeparatedIds,
} from "commonComponents/entity/customField/utils/customFieldTypes/selectCustomFieldUtils";

interface IMultiSelectFieldEditorProps {
    customFieldId: number;
    value: string | null;
    onChange: (newValue: string | null) => void;
    onBlur: () => void;
    definition?: CustomFieldDefinition;
    testId: string;
    formMode?: "always-editing" | "click-to-edit";
}

export function MultiSelectFieldEditor({
    customFieldId,
    value,
    onChange,
    onBlur,
    definition,
    testId,
    formMode,
}: Readonly<IMultiSelectFieldEditorProps>) {
    const treeData = useMemo(() => getOptionsFromDefinition(definition), [definition]);

    const selectedValues = useMemo(() => {
        const parsed = parseCommaSeparatedIds(value ?? "");
        return parsed.length > 0 ? parsed : undefined;
    }, [value]);

    return (
        <BTSelect
            id={`${testId}-${customFieldId}`}
            data-testid={testId}
            value={selectedValues}
            treeData={treeData}
            onChange={(_id, val) => {
                const selected = Array.isArray(val) ? (val as number[]) : [];
                const prevCount = selectedValues?.length ?? 0;
                onChange(selected.length > 0 ? selected.join(",") : null);
                if (selected.length < prevCount) {
                    onBlur();
                }
            }}
            onBlur={() => onBlur()}
            multiple
            formMode={formMode ?? "click-to-edit"}
            placeholder={friendlyDefaultDisplayValue}
        />
    );
}
